const ArrowLeft = ({ className }: { className?: string }) => {
    return (
        <div>
            <svg className={className} viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.5004 26.5599L11.8071 17.8666C10.7804 16.8399 10.7804 15.1599 11.8071 14.1333L20.5004 5.43994"
                    stroke="white"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    );
};

export default ArrowLeft;
